<template>
  <div>
    <h4 class="pt-3 pb-1 text-xs font-semibold text-gray-800">
      {{ $t(`mygwf.components.Label.name`) }}
    </h4>
    <base-fieldset>
      <base-input v-model.trim="name" size="sm" clearable />
    </base-fieldset>

    <base-fieldset>
      <label class="text-xs font-semibold">{{ $t(`mygwf.components.Label.state`) }}</label>
      <div class="relative my-3 space-y-5 text-sm flex flex-col">
        <base-radio
          v-for="type in stateOptions"
          :key="type.label"
          v-model="state"
          :value="type.value"
          :label="type.label"
          name="state"
        />
      </div>
    </base-fieldset>
    <base-fieldset>
      <label class="text-xs font-semibold">Type</label>
      <div class="relative my-3 space-y-5 text-sm flex flex-col">
        <base-radio
          v-for="entry in types"
          :key="entry.label"
          v-model="type"
          :value="entry.value"
          :label="entry.label"
          name="type"
        />
      </div>
    </base-fieldset>
    <base-fieldset>
      <label class="text-xs font-semibold">{{ $t(`mygwf.components.Label.tablet`) }}</label>
      <div class="relative my-3 space-y-5 text-sm flex flex-col">
        <base-select
          :options="tablets"
          v-model="assignedTo"
          :option-type="{id: 'uuid', label: 'name', group: 'company_name'}"
          allowClear
          :open-direction="'bottom'"
          size="sm"
        />
      </div>
    </base-fieldset>
    <base-fieldset>
      <label class="text-xs font-semibold">Discarded</label>
      <div class="relative my-3 space-y-5 text-sm flex flex-col">
        <base-radio
          v-for="option in discardedStatus"
          :key="option.label"
          v-model="discarded"
          :value="option.value"
          :label="option.label"
          name="tabletActive"
        />
      </div>
    </base-fieldset>
  </div>
</template>

<script>
import {
  BaseSelect,
  BaseInput,
  BaseIcon,
  BaseButton,
  BaseButtonIcon,
  BaseFieldset,
  BaseRadio,
} from '@/components/base'
import CompanySelect from '@/components/shared/CompanySelect.vue'
import 'ant-design-vue/lib/popover/style/index.css'
import _isEmpty from 'lodash-es/isEmpty'

export default {
  components: {
    BaseSelect,
    BaseInput,
    BaseIcon,
    BaseFieldset,
    BaseButtonIcon,
    BaseButton,
    CompanySelect,
    BaseRadio,
  },

  props: {
    mobile: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      name: this.$route.query.name || '',
      state: this.$route.query.state || '',
      type: this.$route.query.type || '',
      assignedTo: this.$route.query.assigned_to || '',
      discarded: this.$route.query.discarded || '',
      stateOptions: [
        {label: 'all', value: ''},
        {label: 'assigned', value: '2'},
        {label: 'open', value: '1'},
        {label: 'completed', value: '4'},
        {label: 'inprogress', value: '3'},
      ],
      discardedStatus: [
        {label: 'all', value: ''},
        {label: 'active', value: 'false'},
        {label: 'discarded', value: 'true'},
      ],
      types: [
        {label: 'all', value: ''},
        {label: 'fixed', value: '1'},
        {label: 'free', value: '2'},
      ],
    }
  },

  computed: {
    tablets() {
      const data = this.$store.getters['tablets/getTabletList']
      return data ? data.results : []
    },
  },

  watch: {
    $route(n, o) {
      if (_isEmpty(n.query) && n.name === 'Tours') {
        this.reset()
      }
    },
    name(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'name'})
    },
    state(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'state'})
    },
    type(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'type'})
    },
    assignedTo(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'assigned_to'})
    },
    discarded(n, o) {
      if (this.mobile) {
        return
      }
      this.$store.dispatch('app/filterProp', {value: n, name: 'discarded'})
    },
  },

  methods: {
    submit() {
      let filters = {
        value: [this.name, this.state, this.type, this.assignedTo, this.discarded],
        name: ['name', 'state', 'type', 'assigned_to', 'discarded'],
      }
      this.$store.dispatch('app/filterProp', filters)
    },

    reset() {
      this.name = ''
      this.state = ''
      this.type = ''
      this.assignedTo = ''
      this.discarded = ''
      this.$router.push({name: 'Tours', query: {}})
    },
  },
}
</script>

<style></style>
